import React, { useEffect, useState } from 'react';
import authService from 'services/auth.service';
import userService from 'services/user.service';

const UseBalance = ({ payWithCredit }) => {
    const [currentUser, setCurrentUser] = useState(authService.getCurrentUser());
    const [publicUser, setPublicUser] = useState(null);

    useEffect(() => {
        if (currentUser !== null) {
            userService.getUser()
                .then((response) => {
                    if (response === false) {
                        //tokenService.removeUser();
                        setCurrentUser(null);
                        return;
                    } else {
                        setPublicUser(response.data.publicUser);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    //tokenService.removeUser();
                    setCurrentUser(null);
                    return;
                })
        }
    }, [currentUser]);

    const handleClick = () => {
        payWithCredit();
    };

    return (
        <div className='w-full justify-self-center p-6 bg-blueGray-50 border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 flex flex-col items-center justify-center'>
            {publicUser?.balance > 0 ? (
                <>
                    <h3 className='text-2xl font-bold text-center mb-4'>
                        Tienes {publicUser?.balance} créditos disponibles
                    </h3>
                    <div className='flex flex-row items-center justify-start h-full w-full'>
                        <div className="my-2 w-full flex items-center justify-center px-12">
                            <button
                                className="bg-emerald-500 hover:bg-emerald-600 text-white font-bold py-2 px-4 rounded-lg"
                                onClick={() => handleClick()}
                            >
                                Usar 1 crédito
                                <i className='fas fa-arrow-right text-lg ml-2'></i>
                            </button>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <h3 className='text-2xl font-bold text-center'>No tienes suficientes créditos :(</h3>
                </>
            )}
        </div>
    );
};

export default UseBalance;